export const SET_STUDENT_LESSON_PROBLEM_FLAG = "SET_STUDENT_LESSON_PROBLEM_FLAG";

export interface ISetStudentLessonProblemFlag {
  type: typeof SET_STUDENT_LESSON_PROBLEM_FLAG;
  payload: UpdateStudentLessonProblemFlagStatusPayload;
}

export const HANDLE_UPDATE_STUDENT_LESSON_PROBLEM_FLAG_STATUS =
  "HANDLE_UPDATE_STUDENT_LESSON_PROBLEM_FLAG_STATUS";

export interface IHandleUpdateStudentLessonProblemFlagStatus {
  type: typeof HANDLE_UPDATE_STUDENT_LESSON_PROBLEM_FLAG_STATUS;
  payload: UpdateStudentLessonProblemFlagStatusPayload;
}

export const SET_STUDENT_LESSONS = "SET_STUDENT_LESSONS";

export interface ISetStudentLessons {
  type: typeof SET_STUDENT_LESSONS;
  payload: Lesson[];
}

export const SET_STUDENT_ACTIVE_LESSON = "SET_STUDENT_ACTIVE_LESSON";

export interface ISetStudentActiveLesson {
  type: typeof SET_STUDENT_ACTIVE_LESSON;
  payload: Lesson;
}

export const HANDLE_ASSIGN_LESSONS_TO_STUDENT = "HANDLE_ASSIGN_LESSONS_TO_STUDENT";

export interface IHandleAssignLessonsToStudent {
  type: typeof HANDLE_ASSIGN_LESSONS_TO_STUDENT;
  payload: AssignLessonsStudentRequest;
  fromList: boolean;
}

export const HANDLE_RESCHEDULE_LESSONS = "HANDLE_RESCHEDULE_LESSONS";

export interface IHandleRescheduleLessons {
  type: typeof HANDLE_RESCHEDULE_LESSONS;
  payload: {
    student_lessons: string[];
    student_id: string;
  };
  fromList: boolean;
}

export const HANDLE_FETCH_STUDENT_LESSONS = "HANDLE_FETCH_STUDENT_LESSONS";

/**
 * @params: payload = student_id
 * */
export interface IHandleFetchStudentLessons {
  type: typeof HANDLE_FETCH_STUDENT_LESSONS;
  payload: string;
}

export const HANDLE_EXCUSE_STUDENT_LESSON_LATENESS = "HANDLE_EXCUSE_STUDENT_LESSON_LATENESS";

export interface IHandleExcuseStudentLessonLateness {
  type: typeof HANDLE_EXCUSE_STUDENT_LESSON_LATENESS;
  payload: ExcuseLessonsRequest;
}

export const HANDLE_MARK_STUDENT_LESSONS_FLAGS_REVIEWED =
  "HANDLE_MARK_STUDENT_LESSONS_FLAGS_REVIEWED";

export interface IHandleMarkStudentLessonsFlagsReviewed {
  type: typeof HANDLE_MARK_STUDENT_LESSONS_FLAGS_REVIEWED;
  payload: StudentLessonsRequest;
}

export const HANDLE_RESET_STUDENT_LESSONS = "HANDLE_RESET_STUDENT_LESSONS";

export interface IHandleResetStudentLessons {
  type: typeof HANDLE_RESET_STUDENT_LESSONS;
  payload: StudentLessonsRequest;
}

export const HANDLE_UNASSIGN_STUDENT_LESSONS = "HANDLE_UNASSIGN_STUDENT_LESSONS";

export interface IHandleUnassignStudentLessons {
  type: typeof HANDLE_UNASSIGN_STUDENT_LESSONS;
  payload: StudentLessonsRequest;
}

export const HANDLE_SUBMIT_STUDENT_LESSON_PROBLEMS = "HANDLE_SUBMIT_STUDENT_LESSON_PROBLEMS";

export interface IHandleSubmitStudentLessonProblems {
  type: typeof HANDLE_SUBMIT_STUDENT_LESSON_PROBLEMS;
  payload: SubmitStudentLessonProblemsRequest;
}

export const HANDLE_FETCH_STUDENT_CALENDAR_LESSONS = "HANDLE_FETCH_STUDENT_CALENDAR_LESSONS";

export interface IHandleFetchStudentCalendarLessons {
  type: typeof HANDLE_FETCH_STUDENT_CALENDAR_LESSONS;
}

export const HANDLE_START_STUDENT_LESSON_SECTION = "HANDLE_START_STUDENT_LESSON_SECTION";

export interface IHandleStartStudentLessonSection {
  type: typeof HANDLE_START_STUDENT_LESSON_SECTION;
  payload: StartLessonSectionPayload;
}
